import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface PaymentHistoryData {
    payment_history_idx: number;
    order_idx: number;
    customer_idx: number;
    payment_method: string;
    payment_amount: number;
    current_amount: string;
    manager_name: string;
    payment_memo: string;
    payment_date: string;
}

interface GetPaymentHistoryResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: PaymentHistoryData[];
}

interface GetPaymentHistoryParams {
    customerIdx: number;
    orderIdx?: number;
    page?: number;
}

export const useGetOtherBranchPayment = (params: GetPaymentHistoryParams): UseQueryResult<GetPaymentHistoryResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetPaymentHistoryResponse, Error>({
        queryKey: ["getOBPaymentHistory", params],
        queryFn: async () => {
            const response = await axios.get(
                `${enum_api_uri.get_settlements_payment.replace(":customer_idx", params.customerIdx.toString())}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        page: params.page,
                        order_idx: params.orderIdx,
                    },
                },
            );
            return response.data.data;
        },
        enabled: params.orderIdx !== 0,
        placeholderData: previousData => previousData ?? undefined,
    });
};
